import styled from 'styled-components'

import theme from 'theme_'
import { H1 } from 'components/Typography/Headings'

const statuses: { [char: string]: any } = {
  inactive: {
    background: theme.colors.lighterGrey,
    borderColor: theme.colors.pelicanGrey,
    color: theme.colors.duneWarmGrey,
  },
  active: {
    background: 'rgba(35, 197, 20, .15)',
    borderColor: 'rgba(35, 197, 20, .25)',
    color: theme.colors.successGreen,
  },
  warning: {
    background: `rgba(51, 113, 255, .15)`,
    borderColor: `rgba(51, 113, 255, .25)`,
    color: 'rgb(51, 113, 255)',
  },
  error: {
    background: `rgba(255, 77, 77, .15)`,
    borderColor: 'rgba(255, 77, 77, .25)',
    color: 'rgb(255, 77, 77)',
  },
}

export const PowerCardsWrapper = styled.div`
  margin-top: 16px;
  min-height: 112px;
  gap: 16px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 160px);
`

export const PowerCardWrapper = styled.div<{
  status: string
  isLoading?: boolean
}>`
  background: ${({ status }) => statuses[status].background};
  border-color: ${({ status }) => statuses[status].borderColor};
  color: ${({ status }) => statuses[status].color};
  padding: 16px;
  min-height: 112px;
  max-width 212px;
  min-width 160px;
  flex-grow: 1;
  flex-basis: 0;
  border-radius: 8px;
  border-style: solid;
  border-width: 1px;
  display: flex;
  flex-direction: column;
`

export const PowerCardHeader = styled.div`
  display: flex;
  gap: 20px;
  font-size: 14px;
  font-weight: bold;
  color: ${theme.colors.duneWarmGrey};
`
export const PowerCardHeaderWrapper = styled.div`
  margin-bottom: 16px;
  position: relative;
`

export const PowerText = styled(H1)`
  font-size: 26px;
`
export const ChargePercentageText = styled.span`
  position: absolute;
  font-weight: bold;
  left: 4px;
  top: 26px;
  font-size: 12px;
`
